import { Id } from 'Src/types/aliases'
import { CreateTransportPatentModel, TransportPatentModel } from 'Pages/registratorCabinet'
import { urls } from 'Constants/Urls'
import { SimpleResponse } from 'Types/simpleResponse'
import { axiosDS } from '@pp/axios'

export const transportPatentsApi = {
	getTransportPatents: async (id: Id) => {
		const res = await axiosDS().get<TransportPatentModel[]>(
			urls.cabinet.patent.transport.replace(':rbidos_patent_applications_id', id.toString())
		)
		return res.data
	},
	createTransportPatent: async (id: Id, data: CreateTransportPatentModel) => {
		const res = await axiosDS().post<TransportPatentModel>(
			urls.cabinet.patent.transport.replace(':rbidos_patent_applications_id', id.toString()),
			{ patent_transport: data }
		)
		return res.data
	},
	updateTransportPatent: async (
		patentId: Id,
		transportId: Id,
		data: CreateTransportPatentModel
	) => {
		const res = await axiosDS().patch<TransportPatentModel>(
			`${urls.cabinet.patent.transport.replace(
				':rbidos_patent_applications_id',
				patentId.toString()
			)}/${transportId}`,
			{ patent_transport: data }
		)
		return res.data
	},
	deleteTransportPatent: async (patentId: Id, transportId: Id) => {
		const res = await axiosDS().delete<SimpleResponse>(
			`${urls.cabinet.patent.transport.replace(
				':rbidos_patent_applications_id',
				patentId.toString()
			)}/${transportId}`
		)
		return res.data
	},
}
